import { render, staticRenderFns } from "./SelectTruck.vue?vue&type=template&id=7ed943bb&scoped=true&"
import script from "./SelectTruck.vue?vue&type=script&lang=js&"
export * from "./SelectTruck.vue?vue&type=script&lang=js&"
import style0 from "./SelectTruck.vue?vue&type=style&index=0&id=7ed943bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed943bb",
  null
  
)

export default component.exports